import * as React from "react";

import CardLoading from "./CardLoading";

const SliderLoading = (props: {}) => {
	return (
		<>
			<CardLoading />
			<CardLoading />
			<CardLoading />
		</>
	);
};

SliderLoading.displayName = "SliderLoading";
export default SliderLoading;
